import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getBackgroundList, deletetBackground } from '@blade-sxp/background-management/api/index';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    scene = '';
    result = '';
    keyword = '';
    totalNum = 0;
    pageNum = 1;
    pageSize = 10;
    listLoading = false;
    backgroundList = [];
    mounted() {
        this.getBackgroundList();
    }
    handleSearch() {
        this.pageNum = 1;
        this.getBackgroundList();
    }
    handleReset() {
        this.scene = '';
        this.result = '';
        this.keyword = '';
        this.pageNum = 1;
        this.pageSize = 10;
        this.getBackgroundList();
    }
    handleCreate() {
        this.$router.push('/setting/backgroundManagement/detail');
    }
    getBackgroundList() {
        this.listLoading = true;
        const data = {
            displayResultType: this.result,
            keyword: this.keyword,
            page: this.pageNum,
            sceneType: this.scene,
            size: this.pageSize,
        };
        getBackgroundList(data)
            .then((resp) => {
            this.backgroundList = resp?.list;
            this.totalNum = resp?.total;
        })
            .finally(() => {
            this.listLoading = false;
        });
    }
    formatDeviceGroup(arr) {
        let res = [];
        arr.forEach((item) => {
            res.push(item.name);
        });
        return res.join(',');
    }
    handleEdit(id) {
        // this.$router.push(`/setting/backgroundManagement/detail/${id}`);
        this.$router.push({ path: '/setting/backgroundManagement/detail', query: { id: id } });
    }
    handleDelete(id) {
        this.$elconfirm(this.$t('common.selectDelete').toString(), this.$t('common.warning').toString(), {
            type: 'warning',
            center: true,
            confirmButtonText: this.$t('common.confirm').toString(),
            callback: (action) => {
                if (action === 'confirm') {
                    deletetBackground(id).then((resp) => {
                        this.$message({
                            message: `${this.$t('deletedSuccessfully')}`,
                            type: 'success',
                        });
                        this.refresh();
                    });
                }
            },
        });
    }
    refresh() {
        this.getBackgroundList();
    }
    handleChange(value) {
        this.pageNum = value;
        this.getBackgroundList();
    }
    handleSizeChange(size) {
        this.pageSize = size;
        this.pageNum = 1;
        this.getBackgroundList();
    }
};
default_1 = __decorate([
    Component({
        name: 'backgroundManagement',
        components: {
            AuthItem,
        },
        i18n: {
            messages: {
                en: {
                    scene: 'Scenario',
                    result: 'Result',
                    keyword: 'Keyword',
                    searchHolder: 'Image name/Device Group',
                    sceneOption: [
                        {
                            value: 'PASS',
                            label: 'Pass',
                        },
                    ],
                    resultOption: [
                        {
                            value: 'FACE_MATCH_SUCCESS',
                            label: 'Recognized Success',
                        },
                        {
                            value: 'FACE_MATCH_FAIL',
                            label: 'Recognized Fail',
                        },
                    ],
                    background: 'Device Image',
                    backgroundName: 'Image Name',
                    deviceGroup: 'Device Group',
                    sceneTable: 'Scene',
                    status: 'Status',
                    echo: 'Birthday',
                    updatePerson: 'Updator',
                    updateTime: 'Update Time',
                    operation: 'Operation',
                    confirmDelete: 'confirmDelete',
                    pass: 'Pass',
                    attendance: 'Attendance',
                    payment: 'Payment',
                    face_match_success: 'Recognized Success',
                    face_match_fail: 'Recognized Fail',
                    payment_accept: 'Payment Success',
                    payment_decline: 'Payment Fail',
                    ticket_compare_fail: 'Ticket Comparison Fail',
                    yes: 'Yes',
                    deletedSuccessfully: 'Deleted successfully',
                },
                zh: {
                    deletedSuccessfully: '删除成功',
                    scene: '使用场景',
                    result: '显示结果',
                    keyword: '关键词',
                    searchHolder: '输入背景图名称/设备组',
                    sceneOption: [
                        {
                            value: 'PASS',
                            label: '通行',
                        },
                    ],
                    resultOption: [
                        {
                            value: 'FACE_MATCH_SUCCESS',
                            label: '识别成功',
                        },
                        {
                            value: 'FACE_MATCH_FAIL',
                            label: '识别失败',
                        },
                        {
                            value: 'PAYMENT_ACCEPT',
                            label: '支付成功',
                        },
                        {
                            value: 'PAYMENT_DECLINE',
                            label: '支付失败',
                        },
                        {
                            value: 'TICKET_COMPARE_FAIL',
                            label: '票务比对失败',
                        },
                    ],
                    background: '背景图',
                    backgroundName: '背景图名称',
                    deviceGroup: '关联设备组',
                    sceneTable: '使用场景',
                    status: '显示结果',
                    echo: '生日回显',
                    updatePerson: '更新人',
                    updateTime: '更新时间',
                    operation: '操作',
                    confirmDelete: '确认删除？',
                    pass: '通行',
                    attendance: '考勤',
                    payment: '支付',
                    face_match_success: '识别成功',
                    face_match_fail: '识别失败',
                    payment_accept: '支付成功',
                    payment_decline: '支付失败',
                    ticket_compare_fail: '票务比对失败',
                    yes: '是',
                },
            },
        },
    })
], default_1);
export default default_1;
